import { createTheme } from '@mui/material/styles';

// 'light' theme - Modern & Stylish
const light = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#3c5a98',
			light: '#5b7ab8',
			dark: '#2d4578',
			contrastText: '#ffffff'
		},
		secondary: {
			main: '#4a6a9e',
			light: '#6a8ab8',
			dark: '#2d4578',
			contrastText: '#ffffff'
		},
		background: {
			default: '#f0f4f8',
			paper: '#ffffff',
			topheaderbg: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)',
			menubg: '#ffffff',
			menuhoverbg: '#f1f5f9',
			bluebg: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)',
			bg: '#ffffff',
			subtle: '#f8fafc',
			gradient: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)'
		},
		text: {
			primary: '#1e293b',
			secondary: '#64748b',
			black: '#000000',
			topheadertext: '#ffffff',
			menutext: '#64748b',
			menuhovertxt: '#1e293b',
			kpititle: '#334155',
			link: '#3c5a98'
		},
		divider: '#e2e8f0',
		action: {
			hover: 'rgba(60, 90, 152, 0.08)',
			selected: 'rgba(60, 90, 152, 0.12)',
			focus: 'rgba(60, 90, 152, 0.12)'
		},
		success: {
			main: '#10b981',
			light: '#34d399',
			dark: '#059669'
		},
		warning: {
			main: '#f59e0b',
			light: '#fbbf24',
			dark: '#d97706'
		},
		error: {
			main: '#ef4444',
			light: '#f87171',
			dark: '#dc2626'
		},
		info: {
			main: '#3b82f6',
			light: '#60a5fa',
			dark: '#2563eb'
		}
	},
	typography: {
		fontFamily: '"Inter", "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
		h1: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.025em'
		},
		h2: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.025em'
		},
		h3: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.02em'
		},
		h4: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.02em'
		},
		h5: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600
		},
		h6: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600
		},
		subtitle1: {
			fontWeight: 500,
			letterSpacing: '-0.01em'
		},
		subtitle2: {
			fontWeight: 500,
			letterSpacing: '-0.01em'
		},
		body1: {
			letterSpacing: '-0.01em',
			lineHeight: 1.6
		},
		body2: {
			letterSpacing: '-0.01em',
			lineHeight: 1.5
		},
		button: {
			fontWeight: 500,
			letterSpacing: '0.01em',
			textTransform: 'none'
		}
	},
	shape: {
		borderRadius: 10
	},
	shadows: [
		'none',
		'0 1px 2px 0 rgba(0, 0, 0, 0.05)',
		'0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
		'0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
		'0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
		'0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.25)'
	],
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 10,
					padding: '8px 20px',
					fontWeight: 500,
					boxShadow: 'none',
					transition: 'all 0.2s ease-in-out',
					'&:hover': {
						boxShadow: '0 4px 12px rgba(60, 90, 152, 0.25)',
						transform: 'translateY(-1px)'
					},
					'&:active': {
						transform: 'translateY(0)'
					}
				},
				contained: {
					background: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)',
					'&:hover': {
						background: 'linear-gradient(135deg, #4a6a9e 0%, #2d4578 100%)',
						boxShadow: '0 4px 12px rgba(60, 90, 152, 0.35)'
					}
				},
				outlined: {
					borderWidth: '1.5px',
					borderColor: '#3c5a98',
					'&:hover': {
						borderWidth: '1.5px',
						backgroundColor: 'rgba(60, 90, 152, 0.04)'
					}
				}
			}
		},
		MuiCard: {
			styleOverrides: {
				root: {
					borderRadius: 12,
					boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
					border: '1px solid #e2e8f0',
					transition: 'all 0.2s ease-in-out',
					'&:hover': {
						boxShadow: '0 10px 15px -3px rgba(60, 90, 152, 0.1), 0 4px 6px -4px rgba(60, 90, 152, 0.1)'
					}
				}
			}
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundImage: 'none'
				},
				elevation1: {
					boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)'
				},
				elevation2: {
					boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)'
				},
				elevation3: {
					boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)'
				}
			}
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-root': {
						borderRadius: 10,
						transition: 'all 0.2s ease-in-out',
						'&:hover .MuiOutlinedInput-notchedOutline': {
							borderColor: '#3c5a98'
						},
						'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
							borderWidth: '2px',
							borderColor: '#3c5a98'
						}
					}
				}
			}
		},
		MuiDialog: {
			styleOverrides: {
				paper: {
					borderRadius: 12,
					boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
				}
			}
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					backgroundColor: '#1e293b',
					borderRadius: 8,
					fontSize: '0.75rem',
					padding: '6px 12px'
				}
			}
		},
		MuiChip: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					fontWeight: 500
				}
			}
		},
		MuiTableCell: {
			styleOverrides: {
				head: {
					fontWeight: 600,
					backgroundColor: '#f8fafc',
					color: '#334155'
				}
			}
		},
		MuiTableRow: {
			styleOverrides: {
				root: {
					transition: 'background-color 0.15s ease-in-out',
					'&:hover': {
						backgroundColor: '#f8fafc'
					}
				}
			}
		},
		MuiContainer: {
			styleOverrides: {
				root: {
					padding: 0,
					paddingLeft: '0 !important',
					paddingRight: '0 !important',
					maxWidth: 'none !important'
				}
			}
		}
	}
});

export default light;